// Paleta do logo NOVO DNA + formatadores do Dashboard DNA.
export { C } from '@/design-system/dna';

export const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(v || 0);
export const brlFull = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
export const num = (v) => new Intl.NumberFormat('pt-BR').format(v || 0);
export const pct = (v) => `${(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
